import React, { FC } from 'react';
import styles from './loading.module.css';

const Loading: FC<{ type: 'general' | 'contentFull' }> = ({ type }) => {
  const renderLoading = () => {
    switch (type) {
      case 'general':
        return (
          <div className={styles.loadingGeneralContainer}>
            <div className={styles.loadingGeneralAside}></div>
            <div className={styles.loadingGeneralMain}></div>
          </div>
        );
      case 'contentFull':
        return <div className={styles.loadingContentFull}></div>;
      default:
        return null;
    }
  };

  return (
    <div
      className={type === 'general' ? styles.loadingGeneral : styles.loading}
    >
      {renderLoading()}
    </div>
  );
};

export default Loading;
